export default (input: number | string): number => {
  return typeof input === 'string' ? parseInt(input, 10) : input;
};
